import { forwardRef } from 'react';
import { cn } from '../../util';

const TableRow = forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>(
  ({ className, ...props }, ref) => (
    <tr
      ref={ref}
      className={cn('data-[state=selected]:bg-muted border-table-border border-b transition-colors', className)}
      {...props}
    />
  )
);

TableRow.displayName = 'TableRow';

export default TableRow;
